import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f50ae1a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"left","margin":"auto","padding":"10px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"200px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { mode: "md" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }),
            _createVNode(_component_ion_title, { style: {"font-family":"'Montserrat', sans-serif","font-weight":"700","text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode("Notification Details")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-no-padding",
      style: {"--background":"rgb(239, 246, 255)"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ion_label, { style: {"font-size":"x-large","font-weight":"700"} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.subject), 1)
            ]),
            _: 1
          }),
          _hoisted_2,
          _createVNode(_component_ion_label, {
            style: {"font-weight":"400","font-size":"larger"},
            "text-wrap": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.item.date)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, {
            class: "ion-no-padding",
            lines: "none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, {
                style: {"font-size":"large","font-weight":"600"},
                "text-wrap": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.item.body), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.showChatButton)
            ? (_openBlock(), _createBlock(_component_ion_item, {
                key: 0,
                lines: "none",
                class: "ion-no-padding"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    style: {"width":"-webkit-fill-available","--border-radius":"10px"},
                    color: "primary",
                    onClick: _ctx.chatButton
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View In Unified Inbox")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showWorkOrderButton)
            ? (_openBlock(), _createBlock(_component_ion_item, {
                key: 1,
                lines: "none",
                class: "ion-no-padding"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    style: {"width":"-webkit-fill-available","--border-radius":"10px"},
                    color: "primary",
                    onClick: _ctx.workOrderButton
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View Work Order")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _hoisted_3,
        _createVNode(_component_ion_grid, { class: "ldx-bottom-fixed" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","--border-radius":"10px"},
                      color: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Back")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","--border-radius":"10px"},
                      color: "danger",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mark As Read")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}